import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { TOUR_STEPS } from './help-texts';

/**
 * Tour guiado de primera vez (driver.js, MIT). Recorre el menú lateral
 * explicando el flujo diario del dueño. Se auto-lanza UNA vez por navegador al
 * primer login de un ADMIN (flag en localStorage) y se puede repetir desde el
 * menú de Ayuda del header.
 */
export const TOUR_DONE_KEY = 'conversia.tour.v1.done';

/** ¿Debe auto-lanzarse el tour para este usuario? (solo ADMIN, una vez). */
export function shouldAutoStartTour(role: string | undefined): boolean {
  if (role !== 'ADMIN') return false;
  try {
    return localStorage.getItem(TOUR_DONE_KEY) !== '1';
  } catch {
    return false;
  }
}

function markTourDone(): void {
  try {
    localStorage.setItem(TOUR_DONE_KEY, '1');
  } catch {
    // sin localStorage (modo privado extremo): el tour simplemente se repetirá
  }
}

/** Lanza el tour. Al terminar o saltarlo, queda marcado como visto. */
export function startTour(): void {
  const d = driver({
    showProgress: true,
    progressText: '{{current}} de {{total}}',
    nextBtnText: 'Siguiente',
    prevBtnText: 'Anterior',
    doneBtnText: 'Listo',
    // Cerrar con la X o con Esc = saltar: también cuenta como visto.
    onDestroyed: markTourDone,
    steps: TOUR_STEPS.map((s) => ({
      element: s.element,
      popover: { title: s.title, description: s.description },
    })),
  });
  d.drive();
}
